export const BASE_URL = `https://s9pib444bg.execute-api.ap-south-1.amazonaws.com/commodity`;
// export const BASE_URL = `https://dci8pvww00.execute-api.ap-south-1.amazonaws.com/devStockViewPoint`;
export const API_ROUTES = {
  POST_CALLS: `/admin/postCall`,
  GET_CALLS: `/shared/getCalls`,
  PUT_CALLS: `/admin/updateCall`,
  POST_LOGIN: `/shared/userLogin`,
  POST_FEEDS: `/admin/postFeed`,
  GET_FEED: `/shared/getFeeds`,
  POST_PLANS: `/admin/createPlan`,
  GET_PLANS: `/shared/getPlans`,
  UPDATE_PLANS: `/admin/updatePlan`,
  GET_USERS: `/admin/getDashboardData`,
  GET_FAQ: "/shared/getFAQ",
  POST_FAQ_EDIT_DEL_ADD_UPDATE: "/admin/postFAQ",
  POST_EXTENT_TRIAL_PLAN: "/admin/extendPlan",
  GET_REQUEST_PLANS: `/admin/waitingForApproval`,
  POST_PLAN_APPROVAL: `/customer/planPurchase`,
  DELETE_PLAN: `/admin/callModifications/deleteCall`,
  EDIT_CALL: `/admin/callModifications/editCall`,
  CREATE_COUPON: `/admin/coupon/create`,
  GET_COUPONS: `/shared/coupon/get`,
  USER_REVENUE: `/admin/userAnalytics/userRevenue`,
  USER_ANALYTICS: `/admin/userAnalytics/analytics`,
};
